const TITLE_CASE_SEPARATOR = /[_.\s-]+/;
const REQUEST_TYPE_ACRONYMS = new Map([
  ["api", "API"],
  ["crm", "CRM"],
  ["id", "ID"],
  ["mrr", "MRR"],
  ["pii", "PII"],
  ["url", "URL"],
]);

const formatRequestTypePart = (part: string): string =>
  REQUEST_TYPE_ACRONYMS.get(part.toLowerCase()) ??
  part.charAt(0).toUpperCase() + part.slice(1);

export const resolveApprovalRequestTypeLabel = (
  requestType: string,
): string => {
  const normalized = requestType.trim();

  if (!normalized) {
    return "Approval request";
  }

  if (normalized === "admin.route.access") {
    return "Route access request";
  }

  return normalized
    .split(TITLE_CASE_SEPARATOR)
    .filter(Boolean)
    .map(formatRequestTypePart)
    .join(" ");
};
